<template>
    <div class="pin-comment">
        <div class="pin-comment-wrap">
            <p>
                <router-link :to="{name: 'user', params: {id: comment.author.id}}">{{comment.author.nickname}}: </router-link>
                <router-link :to="{name: 'user', params: {id: comment.reply.author.id}}" class="pin-comment-replied" v-if="hasReply">@{{comment.reply.author.nickname}}</router-link>
                {{getCommentContent(comment.content)}}
            </p>
            <div class="pin-comment-panel">
                <More 
                    :size="16" 
                    @click.native="$emit('setSettings', {comment, type: 'comment'})" />
                <!-- <Reply :size="16" @click.native="$emit('reply', comment)" /> -->
                <Like
                    :class="{show: comment.likes.length > 0}"
                    :active="hasLike" 
                    :likes="comment.likes" 
                    :size="16" 
                    :fsize="12"
                    @click.native="likeHandler()" />
            </div>
        </div>
        <div class="pin-comment-bottom">
            <p class="pin-comment__date">{{$moment(comment.date).locale('ru').fromNow()}}</p>
            <p class="pin-comment__date" @click="$emit('reply', comment)">Ответить</p>
        </div>
        <!-- <div @click="$emit('setSettings', {comment, type: 'comment'})">awdwa</div> -->
    </div>
</template>
<script>
export default {
    name: 'Comment',
    props: {
        comment: {
            type: Object,
            require: true
        }
    },
    components: {
        Like: () => import('./Like.vue'),
        // Reply: () => import('./Reply.vue'),
        More: () => import('./More.vue')
    },
    computed: {
        hasReply() {
            return this.comment.reply ? this.comment.reply : null
        },
        hasLike() {
            return this.getUser && this.comment.likes && this.comment.likes.length > 0 && this.comment.likes.find(like => like && like.author_id === this.getUser.id)
        },
        getUser() {
            return this.$store.getters.getAuthUser
        }
    },
    methods: {
        getCommentContent(value) {
            return value
        },
        sendLike() {
            let user = {
                id: this.getUser.id,
                firstname: this.getUser.firstname,
                lastname: this.getUser.lastname,
                avatar: this.getUser.avatar,
                nickname: this.getUser.nickname,
            };
            this.$store.dispatch('sendPinCommentLike', {
                author_id: this.comment.author_id,
                pin_id: this.comment.pin_id,
                comment_id: this.comment.id
            })
            .then(like => {
                if (like[1]) {
                    this.comment.likes.push({
                        author_id: user.id,
                        author: user,
                        date: like[0].date,
                        pin_id: like[0].pin_id
                    })
                }
            })
            .catch(() => {
                this.$store.dispatch('addError', {message: 'Произошла ошибка'})
            })
        },
        unLike() {
            let comment_id = this.comment.id;
            this.$store.dispatch('sendPinCommentUnLike', {comment_id})
                .then(like => {
                    if (like) {
                        let index = this.comment.likes.indexOf(this.comment.likes.find(lik => lik.author_id === this.getUser.id));
                        this.comment.likes.splice(index, 1)
                    }
                })
        },
        likeHandler() {
            this.hasLike ? this.unLike() : this.sendLike()
        }
    }
}
</script>
<style lang="stylus" scoped>
.pin-comment
    font-size 14px
    line-height 22px
    padding 7px 0px
    padding-top 0
    position relative
    &:hover
        .reply, .more, .like
            opacity 1
    a
        color var(--text-main)
        text-transform lowercase
        font-weight 500
    
    &-wrap
        display flex
        align-items flex-start
        justify-content space-between
    
    &-bottom
        display flex
        align-items center

    &__date
        font-size 10px
        color #333
        margin-right 10px
    
    &-replied
        color #52a3ca !important

    &-panel
        display flex
        align-items center
        padding-left 10px

        .reply, .more, .like
            opacity 0
            transition 0.3s all
            margin-left 8px
            
            &.show
                opacity 1
        

</style>